// Third-party
import React from 'react';

// Components
import ComparisonItem from '@/types/comparison-item';
import { getRiskProfileRuleData } from '@/utils/risk-profiles';
import { Account } from '@/types/planning';
import { formatLocalizedString } from '@/utils/i18n';
import RiskProfileRuleVisualizer from '@/views/components/charts/risk-profile-rule-visualizer/RiskProfileRuleVisualizer';
import { HoldingIcon } from '@/views/components/common';
import { COMPARISON_ITEM_TYPES } from '@/utils/constants';
import { DEFAULT_COMPARISON_ITEM_COLOR, DEFAULT_TARGET_COLOR } from '@/utils/colors';
import Locale from '@/types/locale';
import User from '@/types/user';
import Nullable from '@/types/nullable';

interface Props {
  account: Account;
  comparisonItem: ComparisonItem;
  user: Nullable<User>;
  locale?: Locale;
  hideConfig?: {
    hideRuleLabel: boolean;
    hideBars: boolean;
    hideTable: boolean;
  };
}

const accountHoldingLabel = (account: Account) => (
  <span className="risk-profile-rule-holding">
    <HoldingIcon color={DEFAULT_TARGET_COLOR} type={COMPARISON_ITEM_TYPES.BENCHMARK} />
    {account.name}
  </span>
);

const comparisonItemHoldingLabel = (comparisonItem: ComparisonItem, locale?: Locale) => (
  <span className="risk-profile-rule-holding">
    <HoldingIcon color={DEFAULT_COMPARISON_ITEM_COLOR} type={comparisonItem.type} />
    {formatLocalizedString(comparisonItem.name, locale)}
  </span>
);

// TODO: Figure out best place to move this component. Reused with PlanningAssetAllocationCell in proposals.
const PlanningRiskProfileCompare = (props: Props) => {
  const { account, comparisonItem, locale, hideConfig, user } = props;

  const profile = account.riskProfile;
  const rulesData = profile
    ? profile.rules.map(rule => ({
        rule,
        data: getRiskProfileRuleData(rule, comparisonItem, undefined, user),
      }))
    : [];

  return (
    <div className="planning-risk-profile-compare">
      <div className="risk-profile-data">
        <div className="visualizers">
          {rulesData.map(ruleData => (
            <RiskProfileRuleVisualizer
              key={ruleData.rule.toString()}
              ruleData={ruleData.data}
              rule={ruleData.rule}
              singleRuleLayout={profile.rules.length === 1}
              targetLabel={accountHoldingLabel(account)}
              actualLabel={comparisonItemHoldingLabel(comparisonItem, locale)}
              hideConfig={hideConfig}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PlanningRiskProfileCompare;
